import React, {
  useEffect,
  useState,
} from "react";

import {
  FaChevronLeft,
  FaChevronRight,
  FaCompress,
  FaTimes,
} from "react-icons/fa";

export default function TournamentGalleryLightbox({
  open,
  slide,
  index,
  total,
  onClose,
  onPrevious,
  onNext,
  onTouchStart,
  onTouchEnd,
}) {
  const [
    imageLoaded,
    setImageLoaded,
  ] = useState(false);

  useEffect(() => {
    setImageLoaded(false);
  }, [slide?.src]);

  if (!open || !slide) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 z-[10000] flex items-center justify-center bg-slate-950/95 p-3 backdrop-blur-sm sm:p-6"
      role="dialog"
      aria-modal="true"
      aria-label={`Aperçu de ${slide.title}`}
    >
      <div className="flex h-full w-full max-w-[1600px] flex-col">
        <div className="mb-3 flex items-center justify-between gap-4">
          <div className="min-w-0">
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-orange-300">
              Écran {index + 1} sur{" "}
              {total}
            </p>

            <h3 className="mt-1 truncate text-lg font-bold text-white sm:text-2xl">
              {slide.title}
            </h3>
          </div>

          <button
            type="button"
            onClick={onClose}
            className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl border border-white/15 bg-white/10 text-white transition hover:bg-white/20 focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-300"
            aria-label="Fermer l’aperçu"
          >
            <FaTimes />
          </button>
        </div>

        <div
          className="relative flex min-h-0 flex-1 items-center justify-center overflow-hidden rounded-[28px] border border-white/10 bg-black"
          onTouchStart={
            onTouchStart
          }
          onTouchEnd={
            onTouchEnd
          }
        >
          {!imageLoaded && (
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="h-12 w-12 animate-spin rounded-full border-4 border-white/15 border-t-orange-400" />
            </div>
          )}

          <img
            key={slide.src}
            src={slide.src}
            alt={slide.alt}
            onLoad={() =>
              setImageLoaded(true)
            }
            className={`h-full w-full object-contain transition duration-500 ${
              imageLoaded
                ? "scale-100 opacity-100"
                : "scale-[0.99] opacity-0"
            }`}
          />

          {total > 1 && (
            <>
              <button
                type="button"
                onClick={onPrevious}
                className="absolute left-2 top-1/2 inline-flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-2xl border border-white/15 bg-white/10 text-white shadow-xl backdrop-blur transition hover:bg-orange-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-300 sm:left-4 sm:h-12 sm:w-12"
                aria-label="Image précédente"
              >
                <FaChevronLeft />
              </button>

              <button
                type="button"
                onClick={onNext}
                className="absolute right-2 top-1/2 inline-flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-2xl border border-white/15 bg-white/10 text-white shadow-xl backdrop-blur transition hover:bg-orange-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-300 sm:right-4 sm:h-12 sm:w-12"
                aria-label="Image suivante"
              >
                <FaChevronRight />
              </button>
            </>
          )}

          <button
            type="button"
            onClick={onClose}
            className="absolute bottom-4 right-4 hidden h-11 w-11 items-center justify-center rounded-2xl border border-white/15 bg-white/10 text-white backdrop-blur transition hover:bg-white/20 sm:inline-flex"
            aria-label="Réduire l’image"
            title="Réduire"
          >
            <FaCompress />
          </button>
        </div>

        <p className="mt-3 text-sm leading-6 text-slate-300">
          {slide.description}
        </p>
      </div>
    </div>
  );
}